exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".dialogsend .content{\n  display: flex;\n  justify-content: center;\n}\n\n.dialogsend h1:not(.site-title):before, \n.dialogsend h2:before {\n  display: none;\n}\n", ""]);

